<template>
  <div
    :class="{
      'filter-option--selected': selected,
    }"
    class="filter-option"
    @click="$emit('click')"
  >
    <div class="text-xs font-medium">{{ label }}</div>
  </div>
</template>
<script setup lang="ts">
defineEmits(['click'])
defineProps<{
  label?: string
  count?: number
  selected?: boolean
}>()
</script>

<style lang="postcss" scoped>
.filter-option {
  @apply p-3 rounded-lg border border-gray-300 cursor-pointer bg-white ease-in-out duration-150;

  box-shadow: 0 4px 16px 0 rgba(31, 42, 55, 0.03);
  background: #fff;

  &--selected {
    @apply border-teal-900 text-teal-900;
    box-shadow: 0 4px 16px 0 rgba(31, 42, 55, 0.03);
    background: rgba(214, 240, 242, 0.5);
  }

  &:hover {
    @apply border-teal-900;
  }
}
</style>
